module.exports = __webpack_public_path__ + "static/step4_203-8408fa350faaceabb84a3cad273b1448.png";